import Element from './Element.js';

export default class Iframe extends Element
{
	constructor(parentElement, name)
	{
		super(parentElement, name);
	}

	get tagName()
	{
		return 'iframe';
	}

	get bodyElement()
	{
		return this.element.contentDocument.body;
	}
}